import React from 'react';
import styles from './waiting.module.css';
import { Hourglass } from 'react-loader-spinner';
import { Link } from 'react-router-dom';

export interface WaitingForHostProps{
    link?: string;
    message?: string;
}

const WaitingForHost: React.FC<WaitingForHostProps> = ({ 
    link, message = "WAITING FOR HOST" 
})=>{

    return(
        <div className={`${styles.loadingDisplay}`}>
            <div className={styles.loadingDisplayMessage}>
                <h1>{ message }</h1>
                <Hourglass 
                    colors={['white', 'white']}
                />
            </div>
            {
                link &&
                <span className={styles.linkText}>
                    Click To Start Game: {"  "}
                    <Link
                        to={link}
                        target='_blank'
                    >
                        { link }
                    </Link>
                </span> 
            }
        </div>
    )
}

export default WaitingForHost;